import React, { Fragment } from "react";

import ConfirmButton from "./buttons/ConfirmButton";

const BulkActions = ({ ...props }) => (
  <Fragment>
    <ConfirmButton {...props} />
  </Fragment>
);
export default BulkActions;
